
<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <span class="">{{text}} ({{min}} - {{max}}): <span class="font-weight-semibold">{{doublevalue}}</span></span>
      </div>
    </div>
    <div class="row mt-1">
      <div class="col-12">
        <div style="width:100%" v-bind:id="'slider_' +  getId()" data-fouc></div>
      </div>
    </div>
  </div>
</template>

<script>

  var doublevalue = 0;

	export default {
    name: 'input-slider',
		components: {
    },
    props: {
      value: {
        required: false,
        type: Number,
        default: 20
      },
      min: {
        required: false,
        type: Number,
        default: 0
      },
      max: {
        required: false,
        type: Number,
        default: 100
      },
      step: {
        required: false,
        type: Number,
        default: 1
      },
      text: {
        required: false,
        type: String,
        default: "slider value"
      },
      label: {
        required: false,
        type: String,
        default: ""
      },
    },
    methods: {
      getId() {
        return this._uid;
      },
      handleUpdate(values, handle) {
        var value = values[handle];
        if (handle) {
          this.doublevalue = value;
        } else {
          this.doublevalue = parseFloat(value);
        }
        this.$emit('sliderchanged', this.doublevalue);
      }
    },
    data() {
      return {
        doublevalue
      }
    },
    created() {
      
    },
    mounted() {

      var slider_range = document.getElementById('slider_' + this.getId());

      noUiSlider.create(slider_range, {
        start: [this.value],
        range: {
          'min': this.min,
          'max': this.max
        },
        step: this.step,
      });

      slider_range.noUiSlider.on('update', this.handleUpdate);

      /*
      noUiSlider.create(slider_range, {
        
        behaviour: "none",
        connect: true,
        
        direction: 'ltr'
      });
      */

      // Create slider
      /*
      noUiSlider.create(slider_connect_lower, {
        start: [this.value],
        connect: 'lower',
        range: {
          'min': this.min,
          'max': this.max,
        },
        'step': this.step,

        direction: $('html').attr('dir') == 'rtl' ? 'rtl' : 'ltr'
      });
      */
      //slider_connect_lower.noUiSlider.on('update', this.handleUpdate);


    },
    computed: {

    },
    watch: {

    }
}
</script>

<style>

  .noUi-horizontal {
    height: .375rem;
  }

  .noUi-horizontal .noUi-handle {
    width: 1.125rem;
    height: 1.125rem;
    top: -.375rem;
    right: -.5625rem;
  }
  .noUi-handle {
    background-color: #fff;
    cursor: pointer;
    top: -.375rem;
    position: absolute;
    z-index: 1;
    border: 1px solid #ccc;
    outline: 0;
    width: 1.125rem;
    height: 1.125rem;
    border-radius: 50%;
  }

  .noUi-handle::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -.1875rem;
    margin-left: -.1875rem;
    background-color: #333;
    width: .375rem;
    height: .375rem;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/form-components/input-slider.vue